import React from 'react';
import wb0 from '../img/Detail/accesso_detail.jpg';
import './Detail.css';
const AccessoDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default AccessoDetail;